import { render, staticRenderFns } from "./sorting-header.vue?vue&type=template&id=616377dd"
import script from "./sorting-header.vue?vue&type=script&lang=js"
export * from "./sorting-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports